import { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { DomTomInfos } from '../../../adapters/api-client/referential/Referential.model';
import { LinkCaption } from '../../../styles/LinkStyle';
import { Caption } from '../../../styles/TypoStyle';

const Container = styled.div`
  margin-top: 6px;
`;

const ErrorCaption = styled(Caption)`
  color: var(--colors-error);
  text-align: left;
  a {
    text-decoration: underline;
  }
`;

interface DomtomErrorMessageProps {
  domtomInfo: DomTomInfos;
}

const DomtomErrorMessage: FunctionComponent<DomtomErrorMessageProps> = ({ domtomInfo }): ReactElement => {
  if (domtomInfo.contact) {
    if (domtomInfo.geoloc === 'CTLM') {
      return (
        <>
          <Container className="domtom-error">
            <ErrorCaption>
              L'offre Crédit Moderne est réservée aux particuliers majeurs résidant dans les DOM TOM. Si vous résidez en
              France Métropolitaine, nous vous invitons à faire votre demande en ligne sur le site de{' '}
              <LinkCaption href={domtomInfo.url}>cetelem</LinkCaption>.
            </ErrorCaption>
          </Container>
        </>
      );
    } else {
      return (
        <>
          <Container className="domtom-error">
            <ErrorCaption>
              Pour {domtomInfo.name}, nous vous invitons à faire votre demande en ligne sur le site{' '}
              <LinkCaption href={domtomInfo.url}>Crédit Moderne</LinkCaption> ou vous pouvez contacter le{' '}
              {domtomInfo.contact}.
            </ErrorCaption>
          </Container>
        </>
      );
    }
  } else {
    return (
      <>
        <Container className="domtom-error">
          <ErrorCaption> Votre code postal semble incorrect. Veuillez réessayer.</ErrorCaption>
        </Container>
      </>
    );
  }
};

export default DomtomErrorMessage;
